export default "__VITE_ASSET__61410f85__"